import React, { useState } from "react";
import { Typography, Button, Badge, Switch, Avatar, Spin, Alert } from "antd";
import { DashboardOutlined, MessageOutlined, BulbOutlined, BulbFilled } from "@ant-design/icons";
import { useSignalR } from "Common/hooks/context/SingleRContext";
import { useNavigate } from "react-router-dom";
import useProAdminDashboard from "../Hooks/useProAdminDashboard";

const { Title, Text } = Typography;

export const ProAdminHeader = () => {
  const { unreadMessages } = useSignalR();
  const navigate = useNavigate();
  const { dashboardData, loading, error } = useProAdminDashboard();
  const admin = dashboardData?.admin;

  const [darkMode, setDarkMode] = useState(false);
  const toggleDarkMode = (checked) => setDarkMode(checked);

  

  // Show error state
  if (error) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <Alert
          message="Failed to load dashboard"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <Title level={2} style={{ margin: 0 }}>
          <DashboardOutlined /> CORIQPRO Admin Dashboard
        </Title>

        {loading ? (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Spin size="small" />
            <Text type="secondary">Loading admin data...</Text>
          </div>
        ) : admin ? (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Avatar src={admin.profileImage || undefined} alt="Admin" />
            <Text>{`${admin.firstName} ${admin.lastName}`}</Text>
          </div>
        ) : (
          <Text type="warning">Admin data not available</Text>
        )}
      </div>

      {/* <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
        <Badge count={unreadMessages} size="small" offset={[0, 6]}>
          <Button
            type="text"
            onClick={() => navigate("/messaging")}
            icon={<MessageOutlined style={{ fontSize: 20 }} />}
            shape="circle"
          />
        </Badge>

        <Switch
          checkedChildren={<BulbFilled />}
          unCheckedChildren={<BulbOutlined />}
          checked={darkMode}
          onChange={toggleDarkMode}
        />
      </div> */}
    </div>
  );
};